const TRANSLATION_NAMESPACE = 'jbp-retail-access-denied'

export const TRANSLATION_KEYS = {
  warningMessage: `${TRANSLATION_NAMESPACE}--warning-message`,
  text: `${TRANSLATION_NAMESPACE}--text`,
}
